import React from 'react';
import { Link } from 'react-router-dom';
import Sidebar from '../mendepartmentdetails/Sidebar';
import SubDeptImage from '../../../assets/image/department/casual-senior-man-home-with-doctor_23-2148962325.jpg';

function ElderCareSupport() {
  return (
    <section className="department-details-section">
      <div className="container">
        <div className="row">

          {/* Sidebar */}
          <div className="col-12 col-lg-4 col-xl-4">
            <Sidebar />
          </div>

          {/* Main Content */}
          <div className="col-lg-8">
            <div className="department-details-imgbox">
              <img src={SubDeptImage} className="img-fluid" alt="Elder Care Support and Resources" />
            </div>

            <div className="department-details-content-box">
              <h4 className="department-details-title">Elder Care Support and Resources</h4>
              <p>
                This sub-department focuses on providing essential support and resources for elder care, ensuring that seniors and their caregivers have access to the assistance they need.<br />
                Programs include caregiver support, elder care navigation services, and access to critical resources for aging populations.<br /><br />
                Our mission is to enhance the quality of life for seniors by addressing their unique needs and providing a supportive network for their care.
              </p>
            </div>

            <div className="department-details-benefits-box">
              <h3>Key Services</h3>
              <ul className="list-unstyled list-style">
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Caregiver Support Programs</h5>
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Elder Care Resource Navigation</h5>
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Access to Community Support Services</h5>
                </li>
              </ul>
            </div>

            <div className="department-details-policy-box">
              <h4>Our Commitment:</h4>
              <p>
                We are committed to supporting seniors and their caregivers through comprehensive programs that prioritize dignity, respect, and quality care.
              </p>
            </div>
            <div>
              <Link to="/department/senior-services">
                <i className="fa-solid fa-circle-arrow-left" style={{ marginRight: '5px' }} />
                Go Back
              </Link>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}

export default ElderCareSupport;
